// extracted by mini-css-extract-plugin
export default {"inputText":"styles_inputText__d80vo","container":"styles_container__WuNUw"};